import StarterAssetsDialog from './StarterAssetsDialog';

export default StarterAssetsDialog;
